import {getSession} from '../services/session';

/**
 * Session helpers backed by the backend-provided session payload (HttpOnly cookie
 * auth) instead of decoding the JWT — the token is no longer readable by JS.
 */
export const getTokenExp = () => {
  return getSession().expiresAt;
};
export const getCurrentUserRole = () => {
  return getSession().role;
};
export const getCurrentUserData = () => {
  return getSession().user;
};

export const constructClassNames = (constant, classes) => {
  let classesString = constant;
  classes.forEach(item => {
    if (item.condition && !classesString.length) {
      classesString += item.name;
    } else if (item.condition) {
      classesString += ' ' + item.name;
    }
  });
  return classesString;
};

export const getUserFullName = (id, users) => {
  const user = users.find(x => x.id === id);
  // Some (mostly archived) projects still reference users that no longer
  // exist; rendering them must not crash the whole list.
  if (!user) return "(usunięty użytkownik)";
  return user.firstName + " " + user.lastName;
};

const padTo2Digits = num => {
  return num.toString().padStart(2, "0");
};

export const formatDate = date => {
  return [
    date.getFullYear(),
    padTo2Digits(date.getMonth() + 1),
    padTo2Digits(date.getDate()),
  ].join("-");
};

export const getPropertyPath = (obj, path) => {
  const [head, ...rest] = path.split('.');

  return {
    ...obj,
    [head]: rest.length
      ? getPropertyPath(obj[head], rest.join('.'))
      : ''
  }
};

export const setNestedPropertyValue = (obj, path, value) => {
  const [head, ...rest] = path.split('.');

  return {
    ...obj,
    [head]: rest.length
      ? setNestedPropertyValue(obj[head], rest.join('.'), value)
      : value
  }
};

export const getNestedPropertyValue = (obj, path) => {
  return path.split('.').reduce((o, i)=> o[i], obj);
};

export const getOptionsList = (selections, listName) => {
  return selections.length && selections.find(x => x.name === listName)
    ? selections.find(x => x.name === listName).options
      .map(item => ({id: item.optionId, label: item.option, deleted: item.deleted}))
    : []
};

export const setUTCDate = (date) => {
  const newDate = new Date(date);

  return new Date(
    Date.UTC(
      newDate.getFullYear(),
      newDate.getMonth(),
      newDate.getDate(),
      newDate.getHours(),
      newDate.getMinutes(),
      newDate.getSeconds()
    )
  ).toUTCString();
};

export const convertValueToCurrency = (value) => {
  let currencyValue = (' ' + value).slice(1);
  currencyValue = currencyValue.replace(/^(-)|[.,](?=[^.,]*[.,](?!$))|[,.]+$|[^0-9.,]+/g, '$1');
  currencyValue = currencyValue.replaceAll('.', ',');

  if (currencyValue.includes(",")) {
    let mainValue = currencyValue.split(",").shift();
    if (!mainValue?.length) {
      mainValue = "0";
    }

    let decimalValue = currencyValue.split(",").pop();
    if (!decimalValue?.length) {
      decimalValue = "00";
    } else if (decimalValue?.length === 1) {
      decimalValue = decimalValue + "0"
    } else if (decimalValue > 2) {
      decimalValue = decimalValue.slice(0, 2);
    }

    return mainValue + "," + decimalValue;
  } else {
    let mainValue = currencyValue;
    if (!mainValue?.length) {
      mainValue = "0";
    }

    const decimalValue = "00";

    return mainValue + "," + decimalValue;
  }
};

export const formatValueAsCurrency = value => {
  if (value === undefined) return "-";

  let parts = value.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  if (!parts[1]?.length) {
    parts[1] = "00";
  } else if (parts[1]?.length === 1) {
    parts[1] = parts[1] + "0"
  } else if (parts[1] > 2) {
    parts[1] = parts[1].slice(0, 2);
  }
  return parts.join(",");
};
